// File: webelieve-frontend/src/features/contacts/components/tabs/NotesTab.tsx
// Contact-scoped Notes tab — wraps NotesSplitView with client_id scope

import React from 'react';
import { Contact } from '../../../../config/api';
import NotesSplitView from '../../../notes/components/NotesSplitView';

interface NotesTabProps {
  contact: Contact;
  onUpdate?: (updatedContact: Contact) => void;
}

const NotesTab: React.FC<NotesTabProps> = ({ contact }) => {
  return (
    <div className="h-full min-h-0 overflow-hidden">
      <NotesSplitView clientId={contact.id} />
    </div>
  );
};

export default NotesTab;
